export default __webpack_public_path__ + "static/media/carousel1.772f7213.png";